import React from "react";
import css from "./DemoRightColumn.module.css";
import { SelectFurniture } from "./SelectFurniture/SelectFurniture";
import { STEP, useDemoState } from "@/state/demoState";
import { RoomSetup } from "./RoomSetup/RoomSetup";
import { SELECTED_ITEM_TYPE } from "@/3d/SelectedItem";
import { FurnitureInstanceDetails } from "./FurnitureInstanceDetails/FurnitureInstanceDetails";
import { useFurnitureManagementState } from "@/state/furnitureManagementState";
import { useResourcesState } from "@/state/resourcesState";
import { AABB } from "@/3d/movement2d/aabb2d";
import { OrderDetailsPreview } from "./OrderDetails/OrderDetailsPreview";
import { Column } from "../components/Panel/Column";

export const DemoRightColumn: React.FC = () => {
    const step = useDemoState((state) => state.step);
    const selectedItem = useDemoState((state) => state.selectedItem);
    const setSelectedItem = useDemoState((state) => state.setSelectedItem);
    const roomConfig = useDemoState((state) => state.roomConfig);
    const updateFreeSpace = useFurnitureManagementState((state) => state.updateFreeSpace);

    const deleteFurnitureInstance = useFurnitureManagementState(
        (state) => state.deleteFurnitureInstance
    );
    const createFurnitureInstance = useFurnitureManagementState(
        (state) => state.createFurnitureInstance
    );
    const materials = useResourcesState((state) => state.materials);

    const allFurnitureInstances = useFurnitureManagementState((state) => state.furnitureInstances);
    const allFurniture = useResourcesState((state) => state.furniture);

    const handleOtherVariantSelected = async (otherVariantId: string) => {
        if (!selectedItem || selectedItem.selectedItemType !== SELECTED_ITEM_TYPE.FURNITURE) {
            return;
        }

        const selectedInstanceId = selectedItem.furnitureInstanceId;
        if (!selectedInstanceId) {
            return;
        }

        const otherVariant = allFurniture[otherVariantId];
        const selectedInstance = allFurnitureInstances[selectedInstanceId];

        if (otherVariant && selectedInstance) {
            setSelectedItem(undefined);
            deleteFurnitureInstance(selectedItem.furnitureInstanceId);

            const roomAabb = new AABB(
                -roomConfig.width / 2,
                roomConfig.width / 2,
                -roomConfig.depth / 2,
                roomConfig.depth / 2
            );

            updateFreeSpace(roomAabb);

            const newInstance = await createFurnitureInstance(
                otherVariant,
                materials,
                selectedInstance.instance.position,
                selectedInstance.instance.rotation
            );

            if (newInstance) {
                setSelectedItem({
                    selectedItemType: SELECTED_ITEM_TYPE.FURNITURE,
                    furnitureInstanceId: newInstance.id,
                    instanceId: Object.values(newInstance.instance.meshes)[0].id,
                });
            }
        }
    };

    return (
        <Column className={css.main} gap="20px">
            {step === STEP.FURNITURE_PLACEMENT && <OrderDetailsPreview />}
            {selectedItem !== undefined &&
            selectedItem.selectedItemType === SELECTED_ITEM_TYPE.FURNITURE ? (
                <FurnitureInstanceDetails
                    selectedFurnitureInstanceId={selectedItem.furnitureInstanceId}
                    onBack={() => setSelectedItem(undefined)}
                    onDelete={() => {
                        setSelectedItem(undefined);
                        deleteFurnitureInstance(selectedItem.furnitureInstanceId);
                    }}
                    onOtherVariantSelected={handleOtherVariantSelected}
                />
            ) : (
                <>
                    {step === STEP.ROOM_SETUP && <RoomSetup />}
                    {step === STEP.FURNITURE_PLACEMENT && <SelectFurniture />}
                </>
            )}
        </Column>
    );
};
